/* RESPONSIBLE TEAM: team-automation-foundations */
import HeaderConfiguration from 'embercom/objects/content-editor/header-configuration';

export default HeaderConfiguration.extend({
  component: undefined,

  init(inputs) {
    inputs.component = 'content-editor/headers/view-mode/workflow-header';
    this._super(...arguments);
  },
});
